import React, { useEffect, useState } from 'react';
import { getValue } from 'utils/storage';
import { toast } from 'react-toastify';
import getErrorMessage from 'helpers/errorMessages';
import { getInfoByType } from 'services/info';
import { formattedDate } from 'helpers/formatDate';
import Info from 'services/info/models/info-interface';
import {
  Template,
  BreadCrumb,
  LoadingBg,
  Error,
  MessageError,
} from 'components';
import { Link } from 'react-router-dom';
import { d_technology, m_technology } from 'assets';
import { LADINGPAGE } from 'routes/Constants';
import smoothscroll from 'smoothscroll-polyfill';
import { Container } from './style';

smoothscroll.polyfill();

const TermsOfUsePage: React.FC = () => {
  const [term, setTerm] = useState<Array<Info>>();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    const getPrivacyPolicy = async () => {
      try {
        setError(false);
        setLoading(true);
        const user = getValue<string>({ prop: 'exeltis-user' });
        let terms;

        if (user) {
          terms = await getInfoByType('TERM_MEDIC');
        } else {
          const token = 'Bearer ' + process.env.REACT_APP_UNLOGGED_TOKEN;
          terms = await getInfoByType('TERM_MEDIC', { Authorization: token });
        }
        setTerm(terms);
      } catch (err) {
        const errorMessage = getErrorMessage(err);
        toast.error(errorMessage);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    getPrivacyPolicy();
  }, []);

  if (loading) return <LoadingBg />;
  if (error) return <Error type="LoadFail" />;

  return (
    <Template
      banner={{
        title: 'Termos de Uso',
        imgDesktop: d_technology,
        imgMobile: m_technology,
      }}
      breadcrumb={
        <BreadCrumb
          crumbs={[
            <Link to={`${LADINGPAGE}`}>HOME</Link>,
            <span>Termos de uso</span>,
          ]}
        />
      }
    >
      {term && term.length ? (
        <Container>
          <h2>Termos de uso</h2>
          <h3>
            Esta Política foi modificada pela última vez em{' '}
            {formattedDate(new Date(term[0].date))}.
          </h3>
          <p dangerouslySetInnerHTML={{ __html: term[0].text }} />
        </Container>
      ) : (
        <Container>
          <MessageError content="Sem conteúdo no momento." />
        </Container>
      )}
    </Template>
  );
};

export default TermsOfUsePage;
